const getIframeHeight = (iframeRef) => {
    const { body, documentElement } = iframeRef.current.contentWindow.document;

    return Math.max(
        body.clientHeight,
        body.offsetHeight,
        body.scrollHeight,
        documentElement.clientHeight,
        documentElement.offsetHeight,
        documentElement.scrollHeight
    );
};

export default getIframeHeight;
